
export const constantsPermission = {
    moduleId: {
      leadProspect: 12, 
      leadInquiry: 13,
      assignments: 26,
      task: 27,
      clientVisit:28,
      notes:29, 
      documents:30, 
      jobScope:31, 
      addenda: 32,
      funding:33,
      contigencies:34, 
      specificationException:35,
      contacts:14,
      accounts:15,
      roles:20,
      permissions:21, 
      teams:22, 
      users:23, 
      organization:16,
      businessUnits:19,
      settings:17,
      tasks:18, 
      jonInfo:24, 
      opportuityDetails:25, 
      project:36,
      documentPermission:37,
      saleInfo:38, 
      financial:39,
      printOuts:40,
      permitZoning:41,
      propertyResource:42,
      actionWizards:43, 
    },
}